import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Redirect } from "react-router-dom";
import AppCanvasLoader from "../../components/App/AppCanvasLoader";
import ClientsDashboardChart from "../../components/Clients/ClientsDashboardChart";
import ClientsDashboardSidebar from "../../components/Clients/ClientsDashboardSidebar";
import * as API from "../../utils/api";
import { getDollarAmount } from "../../utils/helpers";
import Emitter from "../../utils/event-emitter";

class ClientsDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      AllMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      upcoming_activities: [],
      recent_activities: [],
      mostAtRiskAccount: [],
      AcpAddCeiReport: [],
      arAgingData: {},
      ACP: [],
      ADD: [],
      months: [],
      year: [],
      cei: 0,
      isLoading: true,
      error: {
        hasAnyError: false,
        statusCode: 200,
      },
    };
    this.minRange = 0;
    this.maxRange = 20;
  }

  componentDidMount() {
    //get initial dashboard details 
    this.dashboardUpcomingEvents();
    this.ArAgingReport();
    this.getAcpAddCeiReport();
    this.getMostAtRiskReport();
  }

  dashboardUpcomingEvents = () => {
    API.dashboardUpcomingEvents(this.props.user).then((data) => {
      Emitter.emit('IS_QUICKBOOK_CONNECTED', data.qb_connected);
      if (typeof data != "undefined" || (data != null && !data.error)) {
        if (data.data) {
          let { recent_activities, upcoming_activities } = data.data;

          //sort recent activities
          if (recent_activities && recent_activities.length) {
            recent_activities.sort(function (a, b) {
              return new Date(b.due_date) - new Date(a.due_date);
            });
          }

          //sort upcoming activities
          if (upcoming_activities && upcoming_activities.length) {
            upcoming_activities.sort(function (a, b) {
              return new Date(a.due_date) - new Date(b.due_date);
            });
          }

          this.setState({ recent_activities, upcoming_activities });
        }
        this.setState({
          isLoading: false,
        });
      } else {
        this.setState((state) => ({
          ...state,
          isLoading: false,
          error: {
            hasAnyError: true,
            statusCode: data
              ? data.status ||
                (data.status_code && data.status_code == 401 ? 401 : 500) ||
                500
              : 500,
          },
        }));
      }
    });
  };

  ArAgingReport = () => {
    API.ArAgingReport(this.props.user).then((data) => {
      if (typeof data != "undefined" || (data != null && !data.error)) {
        if (data.data) {
          this.setState({ arAgingData: data.data });
        }
        this.setState({
          isLoading: false,
        });
      } else {
        this.setState((state) => ({
          ...state,
          isLoading: false,
          error: {
            hasAnyError: true,
            statusCode: data
              ? data.status ||
                (data.status_code && data.status_code == 401 ? 401 : 500) ||
                500
              : 500,
          },
        }));
      }
    });
  };

  getAcpAddCeiReport = () => {
    API.getAcpAddCeiReport(this.props.user).then((data) => {
      if (
        (typeof data != "undefined" || data != null) &&
        data.message === "success"
      ) {
        if (data.data) {
          this.setState({ AcpAddCeiReport: data.data }, () => {
            this.setGraphData();
          });
        }
        this.setState({
          isLoading: false,
        });
      } else {
        this.setState((state) => ({
          ...state,
          isLoading: false,
          error: {
            hasAnyError: true,
            statusCode: data
              ? data.status ||
                (data.status_code && data.status_code == 401 ? 401 : 500) ||
                500
              : 500,
          },
        }));
      }
    });
  };

  getMostAtRiskReport = () => {
    API.getMostAtRiskReport(this.props.user).then((data) => {
      if (
        (typeof data != "undefined" || data != null) &&
        data.message &&
        data.message === "success"
      ) {
        if (data.data) {
          this.setState({ mostAtRiskAccount: data.data });
        }
        this.setState({
          isLoading: false,
        });
      } else {
        this.setState((state) => ({
          ...state,
          isLoading: false,
          error: {
            hasAnyError: true,
            statusCode: data
              ? data.status ||
                (data.status_code && data.status_code == 401 ? 401 : 500) ||
                500
              : 500,
          },
        }));
      }
    });
  };

  //get rounded number for graph
  getRoundedNumber = (num) => {
    let value = 0;
    if (num) {
      num = num.toString().substr(0, 5);
      value = Math.round(num);
    }
    return value;
  };

  //get formatted data for graph like cei value, ACP, ADD, minRange, maxRange, arrays, year and month
  setGraphData = () => {
    let { AcpAddCeiReport } = this.state;
    this.setState({
      cei:
        AcpAddCeiReport.cei && AcpAddCeiReport.cei > 0
          ? AcpAddCeiReport.cei
          : 0,
    });

    if (AcpAddCeiReport && AcpAddCeiReport.acp_add) {
      AcpAddCeiReport.acp_add.map((item, index) => {
        item.average_deliquent_days = item.average_deliquent_days
          ? item.average_deliquent_days
          : 0;
        item.days_sales_outstanding = item.days_sales_outstanding
          ? item.days_sales_outstanding
          : 0;
        this.state.ACP.push(this.getRoundedNumber(item.average_deliquent_days));
        this.state.ADD.push(this.getRoundedNumber(item.days_sales_outstanding));
        this.state.months.push(this.state.AllMonths[item.month - 1]);
        let i = this.state.year.findIndex((o) => o === item.year);
        if (i === -1) {
          this.state.year.push(item.year);
        }
      });
      this.setState(
        {
          ACP: this.state.ACP,
          ADD: this.state.ADD,
          months: this.state.months,
          year: this.state.year,
        },
        () => {
          this.setMinRange(this.state.ACP);
          this.setMaxRange(this.state.ADD);
        }
      );
    }
  };

  //get min value for ACP and ADD
  setMinRange = (data) => {
    if (data && data.length) {
      data.map((item) => {
        if (item) {
          if (parseInt(item) < parseInt(this.minRange)) {
            this.minRange = item;
          }
        }
      });
    }
  };

  //get max value for ACP and ADD
  setMaxRange = (data) => {
    if (data && data.length) {
      data.map((item) => {
        if (item) {
          if (parseInt(item) > parseInt(this.maxRange)) {
            this.maxRange = item;
          }
        }
      });
    }
  };

  //most at risk, row click redirects to consumer account
  handleExpanderClick = (e, d) => {
    e.preventDefault();
    let { history } = this.props;
    const consumerId = d.user_id;
    if (consumerId) {
      history.push(`/client/accounts/${consumerId}`);
    }
  };

  //AR Agging report, get total values
  totalOpenBalance = (arAgingData) => {
    let total = 0;
    if (arAgingData.current) {
      total = parseFloat(total) + arAgingData.current;
    }
    if (arAgingData.report1to30) {
      total = parseFloat(total) + parseFloat(arAgingData.report1to30);
    }
    if (arAgingData.report30to60) {
      total = parseFloat(total) + parseFloat(arAgingData.report30to60);
    }
    if (arAgingData.report60to90) {
      total = parseFloat(total) + parseFloat(arAgingData.report60to90);
    }
    if (arAgingData.report90to120) {
      total = parseFloat(total) + parseFloat(arAgingData.report90to120);
    }
    if (arAgingData.report121plus) {
      total = parseFloat(total) + parseFloat(arAgingData.report121plus);
    }
    return total.toFixed(2);
  };

  //get floatting value like 12.00
  getDecimals = (value) => {
    if (value) {
      return parseFloat(value).toFixed(2);
    }
    return value;
  };

  //render AR Aging Report
  renderReportTable = () => {
    let { arAgingData } = this.state;
    let data = [
      {
        key: "Current",
        value: arAgingData.current
          ? this.getDecimals(arAgingData.current)
          : "0.00",
      },
      {
        key: "1-30 days",
        value: arAgingData.report1to30
          ? this.getDecimals(arAgingData.report1to30)
          : "0.00",
      },
      {
        key: "31-60 days",
        value: arAgingData.report30to60
          ? this.getDecimals(arAgingData.report30to60)
          : "0.00",
      },
      {
        key: "61-90 days",
        value: arAgingData.report60to90
          ? this.getDecimals(arAgingData.report60to90)
          : "0.00",
      },
      {
        key: "91-120 days",
        value: arAgingData.report90to120
          ? this.getDecimals(arAgingData.report90to120)
          : "0.00",
      },
      {
        key: "121+ days",
        value: arAgingData.report121plus
          ? this.getDecimals(arAgingData.report121plus)
          : "0.00",
      },
    ];
    return (
      <div className="report-panel">
        <div className="panel-heading-secondary report-heading-space">
          AR Aging Report
        </div>
        <div className={`panel panel-shadow`}>
          <h3 className="panel-heading report-panel-heading">
            <div className="heading-key" style={{ lineHeight: "200%" }}>
              Total Open Balances:
            </div>
            <div className="heading-value" style={{ lineHeight: "200%" }}>
              {getDollarAmount(this.totalOpenBalance(arAgingData))}
            </div>
          </h3>
          {data.map((item, index) => {
            return (
              <div
                key={index.toString()}
                className={`panel-content report-panel-content ${
                  index % 2 == 0 ? "alt-row" : ""
                }`}
              >
                <div className="content-key">{item.key}</div>
                <div className="content-value">
                  {getDollarAmount(item.value)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  //render Most At-Risk Accounts
  renderRiskAccount = () => {
    let { mostAtRiskAccount } = this.state;
    mostAtRiskAccount = mostAtRiskAccount.slice(0, 6);
    return (
      <div className="at-most">
        <div className="panel-heading-secondary report-heading-space">
          Most At-Risk Accounts
        </div>
        <div className={`panel panel-shadow`}>
          <h3 className="panel-heading report-panel-heading">
            <div className="heading-key">Account</div>
            <div className="heading-value">Amount</div>
            <div className="heading-expander">Go to Account</div>
          </h3>
          {mostAtRiskAccount && mostAtRiskAccount.length ? (
            mostAtRiskAccount.map((item, index) => {
              return (
                <div
                  key={index.toString()}
                  className={`panel-content report-panel-content ${
                    index % 2 == 0 ? "alt-row" : ""
                  }`}
                >
                  <div className="content-key">{item.display_name}</div>
                  <div className="content-value" style={{ paddingRight: 10 }}>
                    {getDollarAmount(item.amount)}
                  </div>
                  <div className="content-expander">
                    <a
                      className={`object-row-expander`}
                      style={{ display: "flex", margin: "auto" }}
                      onClick={(event) => this.handleExpanderClick(event, item)}
                    >
                      <div className={`client-caret expander-caret`} />
                    </a>
                  </div>
                </div>
              );
            })
          ) : (
            <div
              className="admin-admins-empty-state"
              style={{ padding: "3em 2em" }}
            >
              <p>There are currently no Accounts available</p>
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    const { appName } = this.props;
    const {
      isLoading,
      error,
      upcoming_activities,
      recent_activities,
      ACP,
      ADD,
      months,
      year,
      cei,
    } = this.state;

    if (error.hasAnyError) {
      if (error.statusCode == 401) {
        return <Redirect to={{ pathname: "/sign-out" }} />;
      }
    }

    return isLoading ? (
      <AppCanvasLoader />
    ) : (
      <div className="client-scroll-dashboard scrollbar">
        <Helmet>
          <title>{appName} | Dashboard</title>
        </Helmet>
        <div className="app-sidebar-layout-canvas">
          <ClientsDashboardSidebar
            {...this.props}
            user={this.props.user}
            title={"Dashboard"}
            upcoming_activities={upcoming_activities}
            recent_activities={recent_activities}
          />
          <div className="app-sidebar-layout-canvas-content setting-side-canvas big-device-grad col1-scroll scrollbar">
            <ClientsDashboardChart
              months={months}
              year={year}
              ACP={ACP}
              ADD={ADD}
              cei={cei}
              minRange={this.minRange}
              maxRange={this.maxRange}
            />
            <div className="dashboard-report">
              {this.renderReportTable()} {this.renderRiskAccount()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ClientsDashboard;
